<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.productRequirementsLoading"
    :disabled="admin.productRequirementsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Requirement ({{ id }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProductRequirement">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text
      v-show="admin.selectedProductRequirement == null"
    ></v-card-text>
    <v-card-text v-show="admin.selectedProductRequirement != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Requirement saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.productTypeList"
          label="Child Type"
          outlined
          item-text="name"
          item-value="id"
          v-model="childProductTypeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.requirementTypeList"
          label="Requirement Type"
          outlined
          item-text="name"
          item-value="value"
          v-model="requirementType"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.attributeValueList"
          label="Value"
          outlined
          item-text="label"
          item-value="value"
          v-model="value"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProductRequirement != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveProductRequirement"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteRequirement"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedProductRequirement &&
            this.admin.selectedProductRequirement.id != 'new'
          ) {
            tabName = 'Edit Requirement';
          } else if (
            this.admin.selectedProductRequirement &&
            this.admin.selectedProductRequirement.id == 'new'
          ) {
            tabName = 'Add New Requirement';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProductRequirement?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'id',
            value: value
          });
        }
      },
      productId: {
        get() {
          return this.admin.selectedProductRequirement?.productId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'productId',
            value: value
          });
        }
      },
      childProductTypeId: {
        get() {
          return this.admin.selectedProductRequirement?.childProductTypeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'childProductTypeId',
            value: Number(value)
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedProductRequirement?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'attributeId',
            value: Number(value)
          });
          this.$store.dispatch('admin/getAttributeValueList', value);
        }
      },
      requirementType: {
        get() {
          return this.admin.selectedProductRequirement?.requirementType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'requirementType',
            value: value
          });
        }
      },
      value: {
        get() {
          return this.admin.selectedProductRequirement?.value;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'value',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProductRequirement', null);
      },
      /**
       * Saves the product requirement currently being edited
       */
      saveProductRequirement() {
        this.$store
          .dispatch('admin/saveSelectedProductRequirement')
          .then(() => {
            this.showSaveOverlay = true;
            // refresh product list
            this.$store.dispatch('admin/getProductRequirementList');
            setTimeout(() => {
              this.showSaveOverlay = false;
              this.$store.commit('admin/setSelectedProductRequirement', null);
            }, 1500);
          });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteRequirement() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product requirement
       */
      deleteProductRequirement() {
        this.$store
          .dispatch('admin/deleteProductRequirement', this.id)
          .then(() => {
            this.$store.dispatch(
              'admin/getProductRequirementList',
              this.admin.selectedProduct.id
            );
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedProductRequirement', null);
          });
      }
    }
  };
</script>

<style scoped></style>
